export const mainColor = '#c25e4d'
